import { type H3Event, getCookie } from 'h3'

import { getRequestMarket } from '@backmarket/nuxt-module-marketplace/getRequestMarket'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { COOKIE_LANGUAGE } from '../constants'

import { getLocaleFromPath } from './getLocaleFromPath'

/**
 * Extracts the locale from a request.
 *
 * Priority:
 * 1. Path (if present and valid)
 * 2. Cookie (if present)
 * 3. Market default
 */
export function getRequestLocale(event: H3Event) {
  const market = getRequestMarket(event)

  const pathLocale = getLocaleFromPath(event.path)
  if (pathLocale) {
    return toBcp47Locale(pathLocale)
  }

  const cookieLocale = getCookie(event, COOKIE_LANGUAGE)
  if (cookieLocale) {
    return toBcp47Locale(cookieLocale)
  }

  return toBcp47Locale(market.defaultLocale)
}
